import { useAtom } from 'jotai';
import styled from '@xstyled/styled-components';
import useLockBodyScroll from 'hooks/UI/useLockBodyScroll';
import { openFilterAtom } from 'global/store';
import FilterSidebar from './FilterSidebar';
import Button from '@/UI/Button';
import Dismiss from '@/UI/Dismiss';
import { FlexBox, FlexColCenter } from '@/UI/Primitives/FlexBox';
import { useTranslation } from 'next-i18next';

const FilterFlyOut = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  /* min-height: calc(100% + 60px); */
  height: calc(100% + 60px);
  padding: 3rem 2rem;
  background-color: white;
  overflow-x: hidden;
  z-index: 5;
  animation: 0.5s in-out forwards;

  @keyframes in-out {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(0);
    }
  }

  .filter {
    font-size: medium;
    font-weight: bold;
    display: block;
    margin: auto;
  }
`;

export default function MobileFilter() {
  const [isFilterOpen, setOpen] = useAtom(openFilterAtom);
  const { t } = useTranslation();

  // Set overflow-y hidden when filter open
  useLockBodyScroll(isFilterOpen);

  return (
    <FilterFlyOut open={isFilterOpen}>
      <FlexBox align="center" justify="center">
        <Dismiss
          aria-label="Close filter"
          onClick={() => setOpen(false)}
          ml="-0.5rem"
          mt="0.5rem"
        />
        <span className="filter">{t('filter.mobile_apply_filter')}</span>
      </FlexBox>
      <FilterSidebar />
      <FlexColCenter pt="3rem">
        <MobileButton
          onClick={() => setOpen(false)}
          w={{ _: '80%', sm_tablet: '50%' }}
          border="1px solid black"
        >
          {t('filter.mobile_apply_filter')}
        </MobileButton>
        {/* <MobileButton w={{ mobile: '70%', lg_tablet: '40%' }}>
          Eemalda filtrid
        </MobileButton> */}
      </FlexColCenter>
    </FilterFlyOut>
  );
}

const MobileButton = ({ children, ...rest }) => {
  return (
    <Button
      bg="transparent"
      padding="0.5rem 2rem"
      margin={{ _: '1rem 0 1rem 0' }}
      display={{ desktop: 'none' }}
      // style={{ bottom: '30px' }}
      {...rest}
    >
      {children}
    </Button>
  );
};
